module.exports = __webpack_public_path__ + "static/media/textlabel_Step 02.1c172bf0.png";